import { useQuery } from '@tanstack/react-query';

import { supabase } from '../lib/supabase';

export interface UserProfileRow {
  user_id: string;
  full_name: string;
}

export const userProfileQueryKey = ['user-profile', 'self'] as const;

async function fetchSelfProfile(userId: string): Promise<UserProfileRow | null> {
  const { data, error } = await supabase
    .from('user_profiles')
    .select('user_id, full_name')
    .eq('user_id', userId)
    .maybeSingle();
  if (error) throw error;
  return data;
}

export function useUserProfile(userId: string | null) {
  return useQuery({
    queryKey: userProfileQueryKey,
    queryFn: () => {
      if (!userId) return Promise.resolve(null);
      return fetchSelfProfile(userId);
    },
    enabled: Boolean(userId),
    staleTime: 5 * 60 * 1000,
  });
}
